<template>
  <div class="holidayHistory">
    <Header title="审核记录"></Header>
    <NOdata
      v-if="this.list && this.list.length <= 0"
      title="未查询到审核记录"
    ></NOdata>
    <div v-else class="content">
      <div class="item" v-for="(item, index) in list" :key="index">
        <p>审核记录{{ index + 1 }}</p>
        <ul>
          <li>审核人：{{ item.shr }}</li>
          <li>审核时间：{{ item.shsj }}</li>
          <li>审核结果：{{ item.shzt }}</li>
          <li>审核意见：{{ item.shyj }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.getlcShjl({
        ywinstanceid: this.$route.query.list.xsqjid
      });
      console.log(res.data);
      this.list = res.data;
    }
  }
};
</script>

<style lang="less" scoped>
.holidayHistory {
  .content {
    padding: 0 20px;
    .item {
      padding: 20px;
      background: #f8f8f8;
      border-radius: 5px;
      position: relative;
      margin-bottom: 20px;
      p {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        line-height: 42px;
      }
      ul li {
        font-family: PingFangSC-Light;
        font-size: 12px;
        color: #757da3;
        letter-spacing: 0;
        margin-bottom: 1%;
      }
    }
    .item::before {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 2px;
      background: -webkit-repeating-linear-gradient(
        135deg,
        #ff6c6c 0,
        #ff6c6c 20%,
        transparent 0,
        transparent 25%,
        #1989fa 0,
        #1989fa 45%,
        transparent 0,
        transparent 50%
      );
      background: repeating-linear-gradient(
        -45deg,
        #ff6c6c 0,
        #ff6c6c 20%,
        transparent 0,
        transparent 25%,
        #1989fa 0,
        #1989fa 45%,
        transparent 0,
        transparent 50%
      );
      background-size: 80px;
      content: "";
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/holiday/history.vue